"use strict";
import React from "react";
import classNames from 'classnames';
import { CLAIMS, FEATURE_TOGGLES } from '../constants';

const { initAuthentication } = require('../authentication');
const signalR = require("./signalR-net6");
const header = require("./header");
const footer = require("./footer");
const ping = require("./ping");
const loaders = require("./loaders");
const prompt = require("./prompt");
const timeoutPrompt = require("./timeoutPrompt");
const pageAlerts = require("./pageAlerts");
const pageModalContent = require("./pageModalContent");
const devPanel = require("./devPanel");
const anotherDevPanel = require('../devpanel/DevPanel');

const initComponent = (flex = window.flex, Store = window.flex.lib.Store, rx = window.flex.rx, browserHistory = window.flex.browserHistory, FlexApiRequest = window.FlexApiRequest) => {

    const SignalR = signalR(flex);
    const Header = header(flex);
    const Footer = footer(flex);
    const Ping = ping(flex);
    const Prompt = prompt(flex);
    const TimeoutPrompt = timeoutPrompt(flex);
    const PageAlerts = pageAlerts(flex);
    const PageModalContent = pageModalContent(flex);
    const DevPanel = devPanel(flex);

    class AppContainer extends React.Component {
        constructor(props) {
            super(props);
            const clientSidePaths = props.cachedStorePaths || [];
            let initStore = props.initStore || {};
            if (clientSidePaths.length > 0) {
                if (sessionStorage["store"]) {
                    let sessionStore = JSON.parse(sessionStorage["store"]);
                    initStore = _.merge(initStore, sessionStore);
                }
            }

            initStore.moduleName = flex.getModuleName();
            let currentModule = flex.sessionStorage("currentModule");
            if (currentModule != initStore.moduleName) {
                flex.sessionStorage("currentModule", initStore.moduleName);
                flex.sessionStorage("previousPage", false);
                flex.sessionStorage("currentPage", false);
            }

            rx.init(initStore.app || "unknown", initStore, flex, browserHistory);
            initAuthentication(flex, FlexApiRequest);
            this.state = initStore;
        }

        componentWillUnmount() {
            // Unmounting, so stop listening for updates of the store
            Store.off("update");
            sessionStorage.removeItem("store");
        }

        componentDidMount() {
            const me = this;
            flex.scrollToTop(1);

            // Handle updates of the freezer store and force a React update
            let oldStore = flex.getStore();

            Store.on("update", function () {
                const store = flex.getStore();
                const changes = flex.quickDiff(me.oldStore, store);
                flex.log("STORE UPDATED: ", { store: store, changes: changes, diff: JSON.stringify(changes) });
                me.oldStore = store;
                me.forceUpdate();
            });

            Store.on("update", () => {
                const clientSidePaths = this.props.cachedStorePaths || [];
                if (clientSidePaths.length > 0) {
                    const store = flex.getStore();
                    let toSession = this.getPartialPopulatedObject(clientSidePaths, store);
                    sessionStorage["store"] = JSON.stringify(toSession);
                }
            });
            
            flex.trigger("global:get-app-posts");
        }

        getPartialPopulatedObject = (fullPath, store, assignment) => {
            return fullPath.reduce((output, item) => {
                let current = output;
                let parts = item.split('.');

                parts.forEach((part, i) => {
                    let resolved = current[part];
                    if (!resolved) {
                        if (i == parts.length - 1) {
                            current[part] = _.get(store, item);
                        } else {
                            current[part] = {};
                        }
                    }
                    current = current[part];
                });

                return output;
            }, {});
        };

        render() {
            const AnotherDevPanel = anotherDevPanel(flex);
            const store = flex.getStore();
            if (store.pingFailedAt) return (<Ping></Ping>);
            if (!flex.appLoaded() || flex.isBusy("global:session-loggedout")) return loaders.loader;

            // Show server side errors added to context

            let { appContext, session } = store,
                { errors = [] } = appContext;

            if (errors && errors.length > 0) {
                let contextErrors = errors.map((error) => {
                    return (<div className="alert alert-danger">
                        <dl>
                            <dd>Code: </dd>
                            <dt>{error.code}</dt>
                            <dd>Summary: </dd>
                            <dt>{error.summary}</dt>
                        </dl>
                    </div>);
                });

                return (<div id="appContainer">
                    <Header session={session} appContext={appContext}></Header>
                    <section className="container" role="main">
                        {contextErrors}
                    </section>
                    <Footer session={session} appContext={appContext}></Footer>
                </div>);
            }

            // If auth expired, let's show nothing as a safeguard (this shouldn't happen)
            if (!store.session && store.moduleName.toUpperCase().indexOf("PUBLIC") == -1) {
                return false;
            }


            // If a prompt is set in the store, let's render it
            const prompt = !store.prompt ? false : <Prompt {...store.prompt} />;
            const timeoutPrompt = !store.timeoutPrompt ? false : <TimeoutPrompt {...store.timeoutPrompt} />;


            // Render the child app and set the store as a prop
            const app = React.cloneElement(React.Children.only(this.props.children), { store: store, history: "true" });
            const fullScreenLoader = store.showFullScreenLoader === true ? loaders.fullScreenLoader : false;
            const signalRGroups = store.signalRGroups || [];
            const signalR = this.props.excludeSignalR === true ? false : <SignalR signalRGroups={signalRGroups} />;

            const wideContainer = flex.isFeatureToggleEnabled(FEATURE_TOGGLES.WIDE_CONTAINER);
            const interimHeader = flex.isFeatureToggleEnabled(FEATURE_TOGGLES.INTERIM_HEADER);
            const disableWideContainer = flex.claim(CLAIMS.DISABLE_WIDE_CONTAINER);
            const useMDO = flex.claim(CLAIMS.USE_MDO);

            const containerClassNames = classNames(
                store.currentComponentName,
                { 'MDO': useMDO },
                {'wide-container': !disableWideContainer && wideContainer},
                {'MDO-interim-header': interimHeader}
            );

            return (
                <div id="appContainer" className={containerClassNames}>
                    {appContext && appContext.isDevMode && !this.props.hideDevPanel ? <DevPanel /> : false}
                    {appContext && appContext.isDevMode ? <AnotherDevPanel environment={appContext.environment} /> : false}
                    <PageAlerts pageAlerts={store.pageAlerts} />
                    <PageModalContent pageModalContent={store.pageModalContent} />
                    {prompt}
                    {timeoutPrompt}
                    {signalR}
                    {app}
                    {fullScreenLoader}
                </div>)
                ;
        }
    }

    return AppContainer;
};

module.exports = initComponent;

if (window.flex) {
    window.flex.AppContainer = initComponent();
}
